<template>
  <div id="app">
    <router-view />
    <div class="bg_design"></div>
  </div>
</template>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@100;300;500&family=Roboto:wght@100;300;500&display=swap");
#app {
  font-family: "Roboto", "Noto Sans JP", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  padding-bottom: 160px;
  position: relative;
  color: $text_black;
  min-height: 100vh;
  .bg_design {
    position: absolute;
    left: 0;
    top: 0;
    width: 30vw;
    height: 100%;
    background-color: $main_orange;
    @include zIndex(-100);
  }
}

// demo account
// demo site
// poster
//
</style>

<script>
import firebaseUtil from "@/firebase";

export default {
  beforeMount() {
    firebaseUtil.T_redirect().then(() => {
      location.reload();
    });
    firebaseUtil.G_redirect().then(() => {
      location.reload();
    });
  },
  // ログインの処理
  // firebaseに仮データを上げて読み込みの処理をする
  // データ命名規則などを事前に規定しておく
};
</script>
